module.exports = __webpack_public_path__ + "static/media/More.d9f4b6ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/More.svg
// module id = 140
// module chunks = 0